module.exports = __webpack_public_path__ + "static/img/business55.d8d8651.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business55.jpg
// module id = +GSi
// module chunks = 9